import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);

// Lets your app running on localhost skip the real reCAPTCHA check during testing.
// Remove this block once App Check testing is done.
if (window.location.hostname === "localhost") {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

// Exported so other modules (e.g. AuthContext's fetch() calls to
// loginLookup/recordFailedLogin, which are plain HTTP functions and
// don't get an App Check token attached automatically the way
// Firestore/Auth SDK calls do) can request a token and attach it
// themselves via the X-Firebase-AppCheck header.
export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
  isTokenAutoRefreshEnabled: true
});

export const db = getFirestore(app);
//if (window.location.hostname === "localhost") {
  //connectFirestoreEmulator(db, "localhost", 8080);
//}
export const auth = getAuth(app);
export default app;